import axios from 'axios';
import history from '../history'
import { store } from '../store';
let REQUEST;

class Api {
  constructor() {
    if(store.getState().token) axios.defaults.headers.common['Authorization'] = `Bearer ${store.getState().token.accessToken}`;

    //Response Interceptor
    axios.interceptors.response.use(function(response) {
      return response;
    }, function(error) {
      if(error.response.status === 401){
        history.push('/');
      }
      return Promise.reject(error);
    });
  }

  login(url, token) {
    return axios.get(url)
  }

  logout(url, params) {
    return axios.post(url, params)
  }

  get(url, params) {
    return axios.get(url, params)
  }

  post(url, params) {
    return axios.post(url, params)
  }

  put(url, params) {
    return axios.put(url, params)
  }

  delete(url, params) {
    return axios.delete(url, params)
  }

  makeRequest = (config = {}) => {
    if (REQUEST) {
      REQUEST.cancel("Only one request allowed at a time.");
    }
    REQUEST = axios.CancelToken.source();
    config.cancelToken = REQUEST.token
    return axios(config);
  }
}

export default Api;



// WEBPACK FOOTER //
// ./src/services/api.js